import IMSApplicationsFilter from './IMSApplicationsFilter'

export default IMSApplicationsFilter
